export function setNotification(element, state, message) {
  const notification = element.closest('[game]').querySelector('[game--notification]')
  notification.innerText = message
  notification.className = notification.className.replace(/(^|\s)-\w+/g, '') // remove all modifiers
  notification.classList.add(`-${state}`)
  up.reveal(notification, { padding: 30 })
}
